<template>
  <div
    v-fade-on-scroll="$_onScroll"
    class="global-navigation__top"
    :class="{ 'global-navigation__top--page-scrolled': pageScrolled && $route.name !== 'article' }">

    <site-logo
      :show-elements="!pageScrolled"
      @mouseover.native="updateMouseCursor('button')"
      @mouseout.native="updateMouseCursor('default')" />

    <div class="global-navigation__menu" v-show="$route.name !== 'loading' && $route.name !== 'landing'">
      <transition name="morph-burger">
        <router-link
          v-show="$route.name !== 'menu'"
          :to="{ name: 'menu' }"
          class="global-navigation__menu__button global-navigation__menu__button__open"
          @mouseover.native="updateMouseCursor('button')"
          @mouseout.native="updateMouseCursor('default')">
          <div class="menu__button__bar"></div>
          <div class="menu__button__bar menu__button__bar--bottom"></div>
        </router-link>
      </transition>

      <div class="closebuttonWrap">
        <transition name="morph-burger-reverse">
          <router-link
            v-show="open"
            :to="{ name: lastRoute.name, params: lastRoute.params }"
            class="global-navigation__menu__button global-navigation__menu__button__open"
            @mouseover.native="updateMouseCursor('button')"
            @mouseout.native="updateMouseCursor('default')">
            <div class="menu__button__bar"></div>
            <div class="menu__button__bar menu__button__bar--bottom"></div>
          </router-link>
        </transition>

        <transition name="slide-burger">
          <router-link
            v-show="open"
            :to="{ name: lastRoute.name, params: lastRoute.params }"
            class="rossetto-menu__navigation__button__extra-text"
            @mouseover.native="updateMouseCursor('button')"
            @mouseout.native="updateMouseCursor('default')">
            chiudi
          </router-link>
        </transition>
      </div>

    </div>

  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import SiteLogo from './SiteLogo'

export default {
  components: {
    SiteLogo
  },
  data: () => ({
    scrolled: window.pageYOffset > 0,
    pageScrolled: window.pageYOffset >= window.innerHeight
  }),
  props: {
    open: {
      type: Boolean,
      default: false
    },
    lastRoute: {
      type: Object,
      default: () => ({ name: 'landing' })
    }
  },
  methods: {
    ...mapMutations('animations', [
      'updateMouseCursor'
    ]),
    $_onScroll () {
      this.scrolled = window.pageYOffset > 0
      this.pageScrolled = window.pageYOffset >= window.innerHeight - this.$el.offsetHeight
    }
  },
  directives: {
    'fade-on-scroll': {
      bind (el, binding) {
        window.addEventListener('scroll', binding.value)
      },
      unbind (el, binding) {
        window.removeEventListener('scroll', binding.value)
      }
    }
  }
}
</script>

<style lang="scss">
@import '../assets/scss/breakpoint.scss';

$marginLeftRight: 6.25%;
$marginLeftRightDesktop: 3.25%;
$marginTopBottom: 6.25%;
$marginTopBottomDesktop: 3.25%;

$white: #f2f2f2;

.global-navigation__top{
  display: flex;
  position: fixed;
  z-index: 120;
  box-sizing: border-box;
  width: 100%;
  padding: $marginTopBottom $marginLeftRight $marginTopBottom;
  justify-content: space-between;
  @include media(">=large"){
    padding: $marginTopBottomDesktop $marginLeftRightDesktop $marginTopBottomDesktop;
  }
}

.global-navigation__top.menu-first-level{
  padding: 0;
  @include media(">=large"){
    padding: 0;
  }
}

.menu-first-level .siteLogo{
  position: fixed;
  left: 0;
  margin: $marginTopBottom $marginLeftRight $marginTopBottom;
  @include media(">=large"){
    margin: $marginTopBottomDesktop $marginLeftRightDesktop $marginTopBottomDesktop;
  }
}

.global-navigation__top--page-scrolled {
  visibility: hidden;
  z-index: 100;
  display: flex;

  @include media(">=large"){
    visibility: visible;
  }
}

.global-navigation__menu {
  display: flex;
  width: 35px;
  height: 50px;
  align-items: center;
  transform: translateY(-15%);
}

.menu-first-level .global-navigation__menu{
  position: fixed;
  right: 0;
  margin: $marginTopBottom $marginLeftRight $marginTopBottom;
  @include media(">=large"){
    margin: $marginTopBottomDesktop $marginLeftRightDesktop $marginTopBottomDesktop;
  }
}

.global-navigation__menu__button {
  display: flex;
  width: 100%;
  min-height: 24px;
  position: relative;
  line-height: 1;
  text-decoration: none;
  flex-direction: column;
  justify-content: space-between;
}

.menu__button__bar {
  width: 100%;
  height: 2px;
  background-color: $white;
}

.menu__button__bar--bottom {
  transform: translateY(-2px);
}

.closebuttonWrap{
  display: flex;
  align-items: center;
  .global-navigation__menu__button{
    width: 35px;
  }
}

</style>
